import _get from 'lodash/get';
import { imageService } from '@bedrock/fido-sdk';
import { DEFAULT_IMAGE_FORMAT, IMAGE_FIT_SCALE_CROP, IMAGE_QUALITY } from '@bedrock-rdk/constants';
import { getItemActionType } from '../cta/cta.utils';
import { getScreenSize } from '../tornado/utils/sizes';
import { MOSAIC_CARD_SIZE } from '../tornado/mosaic/mosaicCard.style';

export const getImageUrl = item => {
  const screenSize = getScreenSize();

  item.image.src = imageService.getUrl(item.image.id, MOSAIC_CARD_SIZE[screenSize].w, MOSAIC_CARD_SIZE[screenSize].h, {
    fit: IMAGE_FIT_SCALE_CROP,
    quality: IMAGE_QUALITY,
    format: DEFAULT_IMAGE_FORMAT,
  });

  return item;
};

export const filterNavigationEntries = (value, type) => {
  const navigationEntry = _get(value, 'entries', [])
    .flatMap(entry => entry)
    .find(item => {
      if (getItemActionType({ action: item.entry }) === type) {
        const itemImage = _get(item, 'subEntries[0].image');

        if (itemImage) {
          item.subEntries = itemImage.src ? item.subEntries : _get(item, 'subEntries').map(item => getImageUrl(item));
        }

        return true;
      }

      return false;
    });

  return _get(navigationEntry, 'subEntries', []);
};
